import React from "react";
import ImageGallery from "./ImageGallery";

const About: React.FC = () => {
  return (
    <section className="w-full flex items-center justify-center bg-gray-50 py-16">
      <div className="container mx-auto flex flex-col md:flex-row items-center px-8 lg:px-20 max-w-7xl gap-16">
        {/* Left Text Section */}
        <div className="w-full md:w-1/2 text-left">
          <h2
            className="text-xl font-bold text-gray-800 mb-4"
            style={{ fontFamily: "'Bebas Neue', sans-serif" }}
          >
            Träning
          </h2>
          <p
            className="text-lg text-gray-600 leading-relaxed"
            style={{ fontFamily: "'IBM Plex Mono', monospace" }}
          >
            Lada Basteskår är en plats där träning och gemenskap möts. Vi tror
            på att träning ska vara tillgänglig för alla och att det ska vara
            lika roligt som utmanande. Våra gruppträningar erbjuder varierande
            och genomtänkt träning som hjälper dig att nå dina mål, oavsett din
            nivå. Vi tränar i grupper med upp till 20 deltagare, med fokus på
            att ge varje person den hjälp de behöver för att träna på sin egen
            nivå och nå sina mål.
          </p>
        </div>

        {/* Right Image Section */}
        <div className="w-full md:w-1/2 flex justify-center">
          <ImageGallery
            images={[
              "/images/Gallery/DSC00119.jpg",
              "/images/Gallery/DSC09946.jpg",
              "/images/Gallery/DSC09887-min.jpg",
              "/images/Gallery/DSC09976.jpg",
              "/images/Gallery/DSC09732-min.jpg",
            ]}
          />
        </div>
      </div>
    </section>
  );
};

export default About;
